import { useDeviceConfigurationLayout } from 'modules/settings/contexts/device-configuration/hooks/use-device-configuration-layout.hook';
import { useDeviceConfiguration } from 'modules/settings/contexts/device-configuration/hooks/use-device-configuration.hook';
import {
    SettingLayoutContainer,
    SettingsDevicesConfigurationLayoutStyled,
} from '../settings-devices-configuration.style';
import { LayoutState, resolveLayoutState } from './settings-devices-configuration-layout.business';
import { SettingsDevicesConfigurationLayoutContent } from './settings-devices-configuration-layout-content.component';
import { SettingsDevicesConfigurationLayoutLoading } from './settings-devices-configuration-layout-loading.component';
import { SettingsDevicesConfigurationLayoutSectionLoadError } from './settings-devices-configuration-layout-section-load-error.component';

export const SettingsDevicesConfigurationLayout: React.FC = () => {
    const { sectionDetails, sectionTitle, isFlexEnd, isLoading, sectionLoadError, retrySectionDetailsLoad } =
        useDeviceConfigurationLayout();
    const { isPropertyHidden } = useDeviceConfiguration();
    const layoutState = resolveLayoutState({
        isLoading: isLoading ?? false,
        hasSectionDetails: sectionDetails != null,
        hasSectionLoadError: sectionLoadError,
    });

    const contentByState: Record<LayoutState, React.ReactNode> = {
        loading: <SettingsDevicesConfigurationLayoutLoading />,
        error: <SettingsDevicesConfigurationLayoutSectionLoadError onRetry={retrySectionDetailsLoad} />,
        content:
            sectionDetails == null ? null : (
                <SettingsDevicesConfigurationLayoutContent
                    sectionDetails={sectionDetails}
                    sectionTitle={sectionTitle}
                    isFlexEnd={isFlexEnd}
                    isPropertyHidden={isPropertyHidden}
                />
            ),
    };

    return (
        <SettingLayoutContainer>
            <SettingsDevicesConfigurationLayoutStyled>
                {contentByState[layoutState]}
            </SettingsDevicesConfigurationLayoutStyled>
        </SettingLayoutContainer>
    );
};
